import type { ReactNode } from 'react';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'brand';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
}

const variantClass: Record<BadgeVariant, string> = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
  neutral: 'badge-neutral',
  brand: 'badge-brand',
};

export function Badge({ variant = 'neutral', children, className = '', icon }: BadgeProps) {
  return (
    <span className={`badge ${variantClass[variant]} ${className}`}>
      {icon}
      {children}
    </span>
  );
}
